import React from 'react'
import classes from './Backdrop.scss'

const Backdrop = ({ clicked, isSidebar, show }) => {
  let backdropClass = [classes.Backdrop]

  if (isSidebar) {
    backdropClass = [classes.Backdrop, classes.Sidebar]
  }
  return show ? <div className={backdropClass.join(' ')} onClick={clicked}></div> : null
}

export default Backdrop
